"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
import { fetchAboutSectionFile } from "./about.helpers";
export default function AboutGDRC1() {
  const $ = _c(7);
  const [html, setHtml] = useState("");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      fetchAboutSectionFile("gdrc1").then(setHtml);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row><Col><h1>Global Digital Rights Charter</h1></Col></Row>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="https://digitalrightscharter.org/" target="_blank" rel="noopener noreferrer">The Global Digital Rights Charter 1</Link>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Row><Col className="pt-2 pb-2">We support{" "}{t3}.<br /><br />Full text of the GDRC 1 is below.</Col></Row>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== html) {
    t5 = <Container>{t2}{t4}<Row className="pt-1 pb-3"><Col className={styles.htmlContainer} dangerouslySetInnerHTML={{
          __html: html
        }} /></Row></Container>;
    $[5] = html;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}